import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadCarouselProducts from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import {
    getErrorMessage,
    getProductsForProductInfoList,
} from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import ProductListProductGridCard from "@insite/content-library/Widgets/ProductList/ProductListProductGridCard";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import surLoadCarouselProductWithIds from "@tSurya/Handlers/SurLoadCarouselProductWithIds";
import CustomChevronLeft from "@tSurya/Icons/CustomChevronLeft";
import CustomChevronRight from "@tSurya/Icons/CustomChevronRight";
import SurProductListProductGridCrad from "@tSurya/Widgets/Product/SurProductListProductGridCrad";
import { useEmblaCarousel } from "embla-carousel/react";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

const enum fields {
    title = "title",
    numberOfProductsToDisplay = "numberOfProductsToDisplay",
    maxNumberOfColumns = "maxNumberOfColumns",
    showImage = "showImage",
    showTitle = "showTitle",
    showBrandName = "showBrandName",
    showPartNumbers = "showPartNumbers",
    showPrice = "showPrice",
    showAddToCart = "showAddToCart",
    showAddToList = "showAddToList",
    showProductDescription = "showProductDescription",
    cssClass = "cssClass",
    productidlist = "productidlist",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.numberOfProductsToDisplay]: number;
        [fields.maxNumberOfColumns]: number;
        [fields.showImage]: boolean;
        [fields.showTitle]: boolean;
        [fields.showBrandName]: boolean;
        [fields.showPartNumbers]: boolean;
        [fields.showPrice]: boolean;
        [fields.showAddToCart]: boolean;
        [fields.showAddToList]: boolean;
        [fields.showProductDescription]: boolean;
        [fields.productidlist]: string;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    return {
        products: getProductsForProductInfoList(state, ownProps.id),
        errorMessage: getErrorMessage(state, ownProps.id),
        pageType: getCurrentPage(state).type,
    };
};

const mapDispatchToProps = {
    loadCarouselProducts,
    surLoadCarouselProductWithIds,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme> &
    HasShellContext;

export interface ProductCarouselStyles {
    errorMessageText?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    skipCarouselButton?: SkipNavStyles;
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonPresentationProps;
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    carouselProductStyles?: ProductCarouselStyles;
    customproducttilewrapper?: InjectableCss;
    wrapper?: InjectableCss;
    carouselProductWrapper?: InjectableCss;
}

export const productCarouselStyles: ProductCarouselStyles = {
    errorMessageText: {
        color: "danger",
        css: css`
            margin-top: 20px;
        `,
    },
    carouselProductStyles: {
        carouselGridItem: {
            css: css`
                /* border: 1px solid red; */
            `,
        },
    },
    titleText: {
        variant: "h2",
        css: css`
            text-align: center;
            margin-bottom: 72px;
            color: #262525;
            font-weight: 800;
            font-size: 40px;
            line-height: 48px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 32px;
                            margin-bottom: 24px;
                        `,
                        css`
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 32px;
                            margin-bottom: 24px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    mainContainer: {
        gap: 0,
        css: css`
            max-width: 100% !important;
        `,
    },

    customproducttilewrapper: {
        css: css`
            margin: 0 auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-bottom: 30px;
                        `,
                        css`
                            padding-bottom: 30px;
                        `,
                        css`
                            padding-bottom: 30px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    prevArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: 25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: 25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: 25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: 25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: 25px;
                    `,
                ])}
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
        `,
    },
    nextArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: -25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: -25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: -25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: -25px;
                    `,
                    css`
                        flex-basis: 0%;
                        max-width: 0%;
                        position: relative;
                        right: -25px;
                    `,
                ])}
        `,
    },
    nextArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
        `,
    },
    carouselGridItem: {
        width: 10,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                ])}
        `,
    },
    carouselWrapper: {
        css: css`
            width: 100%;
            position: relative;
        `,
    },
    carouselContainer: {
        css: css`
            overflow: hidden;
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                        justify-content: space-between;
                    `,
                    css`
                        flex-wrap: wrap;
                        justify-content: space-between;
                    `,
                    css`
                        flex-wrap: wrap;
                        justify-content: space-between;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    carouselSlide: {
        css: css`
            padding: 0;
            position: relative;
            flex: 0 0 auto;
            margin-top: 5px;
            padding-right: 12px;
            padding-left: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: calc(50% - 5px) !important;
                        padding: 0;
                    `,
                    css`
                        width: calc(50% - 5px) !important;
                        padding: 0;
                    `,
                    css`
                        width: calc(50% - 5px) !important;
                        padding: 0;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    carouselSlideInner: {
        css: css`
            width: 100%;
            height: 100%;
            position: relative;
            padding: 0 2px;
            display: flex;
            flex-direction: column;
        `,
    },
    wrapper: {
        css: css`
            padding-bottom: 61px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 36px;
                    `,
                    css`
                        padding-bottom: 36px;
                    `,
                    css`
                        padding-bottom: 36px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    carouselProductWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            position: relative;
        `,
    },
};

const styles = productCarouselStyles;

const SurCustomProductCarousel: React.FC<Props> = ({
    id,
    theme,
    fields,
    products,
    errorMessage,
    surLoadCarouselProductWithIds,
    // currentTab,
    pageType,
    shellContext,
}) => {
    const afterCarousel = React.createRef<HTMLSpanElement>();
    const isProductDetailsPage = pageType === "ProductDetailsPage";
    const isProductListPage = pageType === "ProductListPage";
    const isBrandDetailsPage = pageType === "BrandDetailsPage";
    const brand = React.useContext(BrandStateContext).value;
    const category = React.useContext(CategoryContext);
    const productContext = React.useContext(ProductContext);
    const [sortedProduct, setSortedProduct] = React.useState<any>();
    const itemArray = fields.productidlist.split(',');

    React.useEffect(() => {
        surLoadCarouselProductWithIds({
            carouselId: id,
            numberOfProductsToDisplay: fields.numberOfProductsToDisplay,
            isProductDetailsPage,
            productId: productContext?.product?.id,
            isProductListPage,
            category,
            isBrandDetailsPage,
            brand,
            productidlist: fields.productidlist,
        });
    }, [fields.numberOfProductsToDisplay, productContext?.product?.id, category?.id, brand?.id, fields.productidlist]);

    const [emblaRef, embla] = useEmblaCarousel();
    const [windowResizeTime, setWindowResizeTime] = React.useState(0);
    const [canScrollPrev, setCanScrollPrev] = React.useState(false);
    const [canScrollNext, setCanScrollNext] = React.useState(false);
    const [activeScroll, setActiveScroll] = React.useState(false);
    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    const getSlidesToScroll = React.useCallback(() => {
        const maxNumberOfColumns = fields.maxNumberOfColumns || 6;
        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let localSlidesToScroll: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 2;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 2;
        } else if (window.innerWidth < theme.breakpoints.values[4]) {
            localSlidesToScroll = 4;
        } else if (window.innerWidth < theme.breakpoints.values[5]) {
            localSlidesToScroll = 4;
        } else {
            localSlidesToScroll = 4;
        }
        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    }, [fields.maxNumberOfColumns]);

    const [slidesToScroll, setSlidesToScroll] = React.useState(getSlidesToScroll());

    const getDraggable = () => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    };

    const [draggable, setDraggable] = React.useState(getDraggable());

    const onWindowResize = () => {
        setWindowResizeTime(Date.now());
    };
    React.useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();
        setSlidesToScroll(newSlidesToScroll);

        const newDraggable = getDraggable();
        setDraggable(newDraggable);
    }, [fields.maxNumberOfColumns, windowResizeTime]);

    React.useEffect(() => {
        if (!embla) {
            return;
        }
        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);
    React.useEffect(() => {
        onWindowResize();
    }, []);

    React.useEffect(() => {
        if (!embla || !products || products.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll,
            draggable,
            loop: products.length > slidesToScroll,
        });
        setCanScroll();
    }, [embla, slidesToScroll, draggable, products, activeScroll]);

    React.useEffect(() => {
        if (itemArray) {
            const SortedProductArray: any[] = [];
            itemArray.forEach((val: any) => {
                const foundProduct = products?.find((item) => item.productNumber === val);
                if (foundProduct) {
                    SortedProductArray.push(foundProduct);
                }
            });
            setSortedProduct(SortedProductArray);
        }
    }, [itemArray]);

    if (errorMessage && shellContext.isInShell) {
        return (
            <Typography {...styles.errorMessageText} as="p">
                {`Failed to load carousel products. Error: '${errorMessage}'. Please check widget settings.`}
            </Typography>
        );
    }

    if (!products || products.length === 0) {
        return null;
    }
    const showBrandBlocks =  products.some(o => !!o.brand);
    const overriddenProps = { ...fields };

    return (
        <>
            <Hidden below="lg">
                <StyledWrapper {...styles.wrapper} onMouseMove={() => setActiveScroll(true)}>
                    <SkipNav
                        text={translate("Skip Carousel")}
                        extendedStyles={styles.skipCarouselButton}
                        destination={afterCarousel}
                    />
                    <StyledWrapper {...styles.customproducttilewrapper}>
                        <GridContainer {...styles.mainContainer} data-test-selector="productCarousel">
                            <GridItem {...styles.prevArrowGridItem}>
                                {products.length > slidesToScroll && (
                                    <Button
                                        {...styles.prevArrowButton}
                                        onClick={() => embla && embla.scrollPrev()}
                                        disabled={!canScrollPrev}
                                        data-test-selector="prevBtn"
                                    >
                                        <ButtonIcon src={CustomChevronLeft} />
                                    </Button>
                                )}
                            </GridItem>
                            <GridItem {...styles.carouselGridItem}>
                                <StyledWrapper {...styles.carouselWrapper}>
                                    <StyledWrapper {...styles.carouselContainer} ref={emblaRef}>
                                        <StyledWrapper {...styles.carouselSlidesContainer} data-test-selector="slides">
                                            {sortedProduct?.map((product: any) => (
                                                <StyledWrapper
                                                    {...styles.carouselSlide}
                                                    key={product.id}
                                                    style={{ width: `calc(100% / ${slidesToScroll})` }}
                                                >
                                                    <StyledWrapper
                                                        {...styles.carouselSlideInner}
                                                        id={`product_${product.id}`}
                                                        data-test-selector="productContainer"
                                                        className="related-productTile"
                                                    >
                                                        <StyledWrapper {...styles.carouselProductWrapper}>
                                                            <SurProductListProductGridCrad
                                                                carouselId={id}
                                                                product={product}
                                                                showImage={true}
                                                                showBrand={showBrandBlocks}
                                                                showTitle={true}
                                                                showPartNumbers={fields.showPartNumbers}
                                                                showPrice={false}
                                                                showAddToCart={false}
                                                                showAddToList={false}
                                                                extendedStyles={styles.carouselProductStyles}
                                                            />
                                                        </StyledWrapper>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            ))}
                                        </StyledWrapper>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </GridItem>
                            <GridItem {...styles.nextArrowGridItem}>
                                {products.length > slidesToScroll && (
                                    <Button
                                        {...styles.nextArrowButton}
                                        onClick={() => embla && embla.scrollNext()}
                                        disabled={!canScrollNext}
                                        data-test-selector="nextBtn"
                                    >
                                        <ButtonIcon src={CustomChevronRight} />
                                    </Button>
                                )}
                            </GridItem>
                        </GridContainer>
                    </StyledWrapper>

                    <span ref={afterCarousel} tabIndex={-1} />
                </StyledWrapper>
            </Hidden>
            <Hidden above="md">
                <StyledWrapper {...styles.wrapper}>
                    <SkipNav
                        text={translate("Skip Carousel")}
                        extendedStyles={styles.skipCarouselButton}
                        destination={afterCarousel}
                    />
                    <StyledWrapper {...styles.customproducttilewrapper}>
                        <GridContainer {...styles.mainContainer} data-test-selector="productCarousel">
                            <GridItem {...styles.carouselGridItem}>
                                <StyledWrapper {...styles.carouselWrapper}>
                                    <StyledWrapper {...styles.carouselSlidesContainer} data-test-selector="slides">
                                        {sortedProduct?.map((product:any) => (
                                            <StyledWrapper
                                                {...styles.carouselSlide}
                                                key={product.id}
                                                style={{ width: `calc(100% / ${slidesToScroll})` }}
                                            >
                                                <StyledWrapper
                                                    {...styles.carouselSlideInner}
                                                    id={`product_${product.id}`}
                                                    data-test-selector="productContainer"
                                                    className="related-productTile"
                                                >
                                                    <StyledWrapper {...styles.carouselProductWrapper}>
                                                        <SurProductListProductGridCrad
                                                            carouselId={id}
                                                            product={product}
                                                            showImage={true}
                                                            showBrand={showBrandBlocks}
                                                            showTitle={true}
                                                            showPartNumbers={fields.showPartNumbers}
                                                            showPrice={false}
                                                            showAddToCart={false}
                                                            showAddToList={false}
                                                            extendedStyles={styles.carouselProductStyles}
                                                        />
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        ))}
                                    </StyledWrapper>
                                </StyledWrapper>
                            </GridItem>
                        </GridContainer>
                    </StyledWrapper>

                    <span ref={afterCarousel} tabIndex={-1} />
                </StyledWrapper>
            </Hidden>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withIsInShell(withTheme(SurCustomProductCarousel))),
    definition: {
        group: "Common",
        icon: "Carousel",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 0,
            },
            {
                name: fields.numberOfProductsToDisplay,
                displayName: "Number Of Products To Display",
                editorTemplate: "IntegerField",
                min: 1,
                max: 20,
                defaultValue: 10,
                fieldType: "General",
                sortOrder: 5,
            },
            {
                name: fields.productidlist,
                displayName: "Product Ids",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 7,
            },
            {
                name: fields.maxNumberOfColumns,
                displayName: "Max Number Of Columns",
                editorTemplate: "IntegerField",
                min: 1,
                max: 6,
                defaultValue: 6,
                fieldType: "General",
                sortOrder: 8,
            },
        ],
    },
};

export default widgetModule;
